import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=32dde4d2&scoped=true&"
import script from "./ProjectsOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsOverview.vue?vue&type=style&index=0&id=32dde4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dde4d2",
  null
  
)

export default component.exports